angular.module('angus.directives').directive('usersReportDetails', [
    'actionViewTemplates',
    function(actionViewTemplates) {
        return {
            scope: {
                settings: "=",
            },
            restrict: 'E',
            templateUrl: actionViewTemplates.usersReportDetails
        }
    }
]);